const API_POLICY_PRIMARY = 'primary'
const API_POLICY_HYBRID = 'hybrid'
const API_POLICY_STATIC = 'static'

function createRule({ methods = ['*'], pattern, policy, description }) {
  return {
    methods: methods.map((method) => String(method || '*').toUpperCase()),
    pattern,
    policy,
    description
  }
}

function normalizeRequestPath(url) {
  return String(url || '')
    .replace(/^[a-z]+:\/\/[^/]+/i, '')
    .replace(/^\/+/, '')
    .replace(/\?.*$/, '')
}

const apiRequestPolicyRules = [
  createRule({
    methods: ['POST'],
    pattern: /^api\/auth\/request-otp$/,
    policy: API_POLICY_HYBRID,
    description: 'Start phone call login confirmation'
  }),
  createRule({
    methods: ['GET'],
    pattern: /^api\/auth\/phone-confirmation\/[^/]+$/,
    policy: API_POLICY_HYBRID,
    description: 'Poll call confirmation status'
  }),
  createRule({
    methods: ['POST'],
    pattern: /^api\/auth\/verify-otp$/,
    policy: API_POLICY_HYBRID,
    description: 'Finalize phone call login'
  }),
  createRule({
    methods: ['POST'],
    pattern: /^api\/auth\/totp\/check-phone$/,
    policy: API_POLICY_HYBRID,
    description: 'Check public TOTP availability by phone'
  }),
  createRule({
    methods: ['POST'],
    pattern: /^api\/auth\/totp\/login$/,
    policy: API_POLICY_HYBRID,
    description: 'Direct TOTP login'
  }),
  createRule({
    methods: ['POST'],
    pattern: /^api\/auth\/totp\/verify-login$/,
    policy: API_POLICY_HYBRID,
    description: 'Complete MFA TOTP login'
  }),
  createRule({
    methods: ['POST'],
    pattern: /^api\/webauthn\/check-phone$/,
    policy: API_POLICY_HYBRID,
    description: 'Check public WebAuthn availability by phone'
  }),
  createRule({
    methods: ['POST'],
    pattern: /^api\/webauthn\/authenticate\/generate$/,
    policy: API_POLICY_HYBRID,
    description: 'Generate public WebAuthn authentication options'
  }),
  createRule({
    methods: ['POST'],
    pattern: /^api\/webauthn\/authenticate\/verify$/,
    policy: API_POLICY_HYBRID,
    description: 'Verify public WebAuthn authentication'
  }),
  createRule({
    methods: ['GET', 'PATCH'],
    pattern: /^api\/auth\/me$/,
    policy: API_POLICY_HYBRID,
    description: 'Authenticated profile bootstrap and update'
  }),
  createRule({
    methods: ['GET', 'PUT'],
    pattern: /^api\/auth\/settings$/,
    policy: API_POLICY_HYBRID,
    description: 'Authenticated settings bootstrap and update'
  }),
  createRule({
    methods: ['GET'],
    pattern: /^api\/cards\/mine\/list$/,
    policy: API_POLICY_HYBRID,
    description: 'Authenticated dashboard cards bootstrap'
  }),
  createRule({
    methods: ['GET'],
    pattern: /^api\/payments\/subscriptions\/mine$/,
    policy: API_POLICY_HYBRID,
    description: 'Authenticated subscription bootstrap'
  }),
  createRule({
    methods: ['GET'],
    pattern: /^api\/payments\/methods\/mine$/,
    policy: API_POLICY_HYBRID,
    description: 'Authenticated payment methods bootstrap'
  }),
  createRule({
    methods: ['GET'],
    pattern: /^api\/cards\/[^/]+\/status$/,
    policy: API_POLICY_HYBRID,
    description: 'Public card activation status'
  }),
  createRule({
    methods: ['POST'],
    pattern: /^api\/cards\/[^/]+\/activate$/,
    policy: API_POLICY_HYBRID,
    description: 'Card activation flow'
  }),
  createRule({
    methods: ['POST'],
    pattern: /^api\/cards\/[^/]+\/share-contact$/,
    policy: API_POLICY_HYBRID,
    description: 'Public share-contact flow'
  }),
  createRule({
    methods: ['GET'],
    pattern: /^card\/[^/]+$/,
    policy: API_POLICY_HYBRID,
    description: 'Public card backend fallback data'
  }),
  createRule({
    methods: ['GET'],
    pattern: /^card\/[^/]+\/contact$/,
    policy: API_POLICY_HYBRID,
    description: 'Public card backend fallback vCard'
  })
]

const staticResourcePolicyRules = [
  {
    target: '/{cardId}/data.json',
    policy: API_POLICY_STATIC,
    description: 'Primary public card payload from static storage'
  },
  {
    target: '/{cardId}/avatar.png',
    policy: API_POLICY_STATIC,
    description: 'Primary public card avatar from static storage'
  },
  {
    target: '/{cardId}/contact.vCard',
    policy: API_POLICY_STATIC,
    description: 'Primary public card contact export from static storage'
  }
]

function matchRequestPolicyRule(method, url) {
  const normalizedMethod = String(method || 'GET').toUpperCase()
  const normalizedPath = normalizeRequestPath(url)

  return apiRequestPolicyRules.find((rule) => {
    const methodMatches = rule.methods.includes('*') || rule.methods.includes(normalizedMethod)
    return methodMatches && rule.pattern.test(normalizedPath)
  })
}

function resolveApiRequestPolicy(method, url) {
  return matchRequestPolicyRule(method, url)?.policy || API_POLICY_PRIMARY
}

export {
  API_POLICY_HYBRID,
  API_POLICY_PRIMARY,
  API_POLICY_STATIC,
  apiRequestPolicyRules,
  matchRequestPolicyRule,
  normalizeRequestPath,
  resolveApiRequestPolicy,
  staticResourcePolicyRules
}
